import React, { createContext, useContext, useEffect, useState } from 'react';
import { getCustomerPortalInstanceService } from '../services/customerPortalInstanceService';

const CustomerPortalInstancesContext = createContext();

export function CustomerPortalInstancesProvider({ children }) {
    const [instanceData, setInstanceData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchInstance = async () => {
            try {
                const hostname = window.location.hostname;
                const data = await getCustomerPortalInstanceService(hostname);
                sessionStorage.setItem('cp_modelTypeID', String(data.modelTypeID));
                sessionStorage.setItem('cp_entityID', String(data.entityID));
                setInstanceData(data);
            } catch (err) {
                console.error('Error fetching customer portal instance:', err);
                setError(err);
            } finally {
                setLoading(false);
            }
        };
        fetchInstance();
    }, []);

    if (loading) return null;
    if (error) return <div>Error loading application configuration.</div>;

    return (
        <CustomerPortalInstancesContext.Provider
            value={{ modelTypeID: instanceData?.modelTypeID, entityID: instanceData?.entityID }}
        >
            {children}
        </CustomerPortalInstancesContext.Provider>
    );
}

export function useCustomerPortalInstance() {
    const context = useContext(CustomerPortalInstancesContext);
    if (!context) {
        throw new Error('useCustomerPortalInstance must be used within a CustomerPortalInstancesProvider');
    }
    return context;
}
